import { ReactNode, useContext } from "react";
import { ModalContext } from "./AppLayoutModalProvider";
import { IllegalStateError } from "shared-ts-utils-core";

export interface UseModalReturnType {
  modal?: ReactNode;
  setModal: (modal: ReactNode | undefined) => void;
  closeModal: () => void;
}

export const useAppLayoutModal = (): UseModalReturnType => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new IllegalStateError("useAppLayoutModal must be used within a AppLayoutModalProvider");
  }
  return context;
};
